import { render, staticRenderFns } from "./aftersales.vue?vue&type=template&id=12955b72&scoped=true&"
import script from "./aftersales.vue?vue&type=script&lang=js&"
export * from "./aftersales.vue?vue&type=script&lang=js&"
import style0 from "./aftersales.vue?vue&type=style&index=0&id=12955b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12955b72",
  null
  
)

export default component.exports